var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGodRays(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 343,
    height: 56,
    viewBox: "0 0 343 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.17,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M-20.9688 -196.57L124.5 27.8783L24.6406 -196.57H-20.9688ZM-100.5 -50.3578L124.5 27.8783L-100.5 -92.3383V-50.3578ZM-100.5 -196.57V-148.552L124.5 27.8783L-84.4078 -196.57H-100.5ZM144.163 -196.57L124.5 27.8783L180.364 -196.57H144.163ZM-100.5 26.86L124.5 27.8783L-100.5 -8.54877V26.86ZM349.5 -8.54877L124.5 27.8783L349.5 26.86V-8.54877ZM224.359 -196.57L124.5 27.8783L269.97 -196.57H224.359ZM349.5 -196.57H333.408L124.5 27.8783L349.5 -148.552V-196.57ZM349.5 -92.3383L124.5 27.8783L349.5 -50.3578V-92.3383ZM68.6375 -196.57L124.5 27.8783L104.839 -196.57H68.6375ZM329.861 252.57L124.5 27.8783L273.041 252.57H329.861ZM-100.5 103.836L124.5 27.8783L-100.5 66.3998V103.836ZM222.033 252.57L124.5 27.8783L182.597 252.57H222.033ZM349.5 66.3998L124.5 27.8783L349.5 103.836V66.3998ZM349.5 150.73L124.5 27.8783L349.5 201.039V150.73ZM-24.0406 252.57L124.5 27.8783L-80.8593 252.57H-24.0406ZM-100.5 201.039L124.5 27.8783L-100.5 150.729V201.039ZM66.4047 252.57L124.5 27.8783L26.9688 252.57H66.4047ZM142.127 252.57L124.5 27.8783L106.875 252.57H142.127Z",
    fill: "url(#paint0_radial_4841_102358)",
    fillOpacity: 0.6
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_4841_102358",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(123.875 28) scale(253.75 253.265)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#01A8F3"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGodRays);
export default __webpack_public_path__ + "static/media/god_rays.21102d7788dee313f158bc3729af5ceb.svg";
export { ForwardRef as ReactComponent };